module.exports = __webpack_public_path__ + "static/media/mmz.86f745ac.png";